<template>
  <div class="note-editorarea">
    <ul class="note-editor">
      <li class="note-editor-item note-editor-block-01">
        <p class="note-editor-title">ノートのタイトル</p>
        <div class="formparts text mb20">
          <input type="text" name="text" placeholder="株式会社Aの調査" ref="titleRef" v-model="detail.title">
          <p v-if="validate.title" class="error-message">{{validate.title}}</p>
        </div>
        <ul class="list-sup" v-if="state.isEdit">
          <li>作成日：{{formatDate(detail.created)}}</li>
          <li>更新日：{{formatDate(detail.modified)}}</li>
        </ul>
      </li>
      <li 
        v-show="state.isShareAreaShown"
        class="note-editor-item note-editor-item-02">
        <p class="note-editor-title">共有指定</p>
        <div class="formparts radio inline">
          <input type="radio" id="note_edit_01" 
            :value="1" 
            v-model.number="detail.share_type"
            @change="share.onShareTypeChanged">
          <label for="note_edit_01">プライベート</label>
        </div>
        <div class="formparts radio">
          <input type="radio" id="note_edit_02" 
            :value="2" 
            v-model.number="detail.share_type"
            @change="share.onShareTypeChanged">
          <label for="note_edit_02">共有</label>
        </div>
        <p class="error-message" 
          v-if="detail.share_type === 2 && !state.isSaving && !share.isUsersToShareSelected"
          >アカウントを指定してください。</p>
        <div 
          class="formparts-hidden"
          v-show="detail.share_type === 2">
          <div class="formparts radio">
            <input type="radio" id="note_edit_21" 
              :value="21" 
              v-model.number="detail.share_classification"
              @click="share.onShareClassificationClicked(21, true)"
              :disabled="detail.share_type !== 2">
            <label role="button" for="note_edit_21">閲覧権限を付与する</label>
            <a class="txt-blue" role="button"
              v-if="detail.share_classification === 21 && share.isUsersToShareSelected"
              @click="share.onShareClassificationClicked(21, false)">閲覧・編集</a>
          </div>
          <div class="formparts radio">
            <input type="radio" id="note_edit_22" 
              :value="22" 
              v-model.number="detail.share_classification"
              @click="share.onShareClassificationClicked(22, true)"
              :disabled="detail.share_type !== 2">
            <label role="button" for="note_edit_22">編集権限を付与する</label>
            <a class="txt-blue" role="button"
              v-if="detail.share_classification === 22 && share.isUsersToShareSelected"
              @click="share.onShareClassificationClicked(22, false)">閲覧・編集</a>
          </div>
        </div>
      </li>
      <li 
        v-show="state.isTagAreaShown"
        class="note-editor-item note-editor-item-03">
        <p class="note-editor-title">タグの追加</p>
        <div class="formparts function mb20">
            <input type="text" @keydown.enter="tags.addTag" v-model="tags.newTag">
            <div @click="tags.addTag" class="button" role="button"><span class="icn register">登録</span></div>
        </div>
        <span role="button" class="txt-blue"
          @click="state.isOpenHistoryTags = !state.isOpenHistoryTags"
          :class="{'is-open' : state.isOpenHistoryTags}"
        >登録済のタグから追加
          <FontawesomeIcon icon="angle-down" class="icn" v-if="state.isOpenHistoryTags" />
          <FontawesomeIcon icon="angle-up" class="icn" v-else />
        </span>
        <div class="note-editor-tags note-editor-tags-history mt8"
          v-if="state.isOpenHistoryTags"
        >
          <div v-for="(history, index) in tags.history" :key="'history_tag_' + index" class="tag bottom">
            <div @click="tags.addEditTag(history)" role="button" class="tag-wrap">
              <span class="tag-text">{{history.name}}</span>
            </div>
          </div>
        </div>
        <div v-if="detail.tags.length > 0" class="note-editor-tags mt8">
          <div v-for="(tag, index) in detail.tags" :key="'detail_tag_' + index" class="tag">
            <div @click="tags.removeEditTag(tag)" role="button" class="tag-wrap">
              <span class="tag-text">{{tag.name}}</span>
              <span class="tag-close"><FontawesomeIcon icon="times" size="xs" class="icn" /></span>
            </div>
          </div>
        </div>
      </li>
    </ul>

    <div class="note-editor-parts">
      <div role="button" slot="header" class="button plus is-top" @click="listAction.add.open(-1)">
        <span class="btn"><FontawesomeIcon :icon="['fal','plus']" class="icn" /></span>
      </div>
      <template v-for="(list, index) in detail.lists">
        <div :key="'parts_' + index" class="note-editor-parts-item">
          <template v-if="list.type === 0">
            <p class="note-editor-title">見出し</p>
            <div class="formparts text">
              <input type="text" v-model="list.content">
            </div>
          </template>

          <template v-else-if="list.type === 1">
            <p class="note-editor-title">コメント</p>
            <div class="formparts textarea">
              <textarea rows="5" v-model="list.content"></textarea>
            </div>
          </template>

          <template v-else-if="list.type === 2">
            <p class="note-editor-title">リンク</p>
            <div class="note-editor-parts-linkarea">
              <p v-if="list.knowledge.deleted === 1" class="note-editor-parts-linkarea-sup2">閲覧できなくなりました。</p>
              <p class="note-editor-parts-linkarea-title">{{list.knowledge.name}}</p>
              <p class="note-editor-parts-linkarea-sup"><span class="category-item">最新ナレッジ</span><span class="category-item">{{list.knowledge.knowledge_type_name}}</span></p>
              <p class="note-editor-parts-linkarea-sup">{{formatDate(list.knowledge.created)}}</p>
            </div>
          </template>

          <template v-else-if="list.type === 3">
            <p class="note-editor-title">リンク</p>
            <div class="note-editor-parts-linkarea">
              <!-- <p v-if="list.qa.deleted === 1" class="note-editor-parts-linkarea-sup2">閲覧できなくなりました。</p> -->
              <p v-if="list.qa.auth_message">{{list.qa.auth_message}}</p>
              <!-- <p v-else-if="list.qa.latest_id && list.qa.id !== list.qa.latest_id" class="note-editor-parts-linkarea-sup2">更新されました。</p> -->
              <p class="note-editor-parts-linkarea-title">{{list.qa.name}}</p>
              <p class="note-editor-parts-linkarea-sup">Q&A・事例</p>
              <p v-if="list.qa.year !== 'マスターインデックス'" class="note-editor-parts-linkarea-sup">{{list.qa.year}}</p>
            </div>
          </template>

          <template v-else-if="list.type === 4">
            <p class="note-editor-title">リンク</p>
            <div class="note-editor-parts-linkarea">
              <p v-if="list.pj.auth_message">{{list.pj.auth_message}}</p>
              <p class="note-editor-parts-linkarea-title">{{list.pj.name}}</p>
              <p class="note-editor-parts-linkarea-sup">資料</p>
            </div>
          </template>
          
          <div class="note-editor-parts-button">
            <span class="note-editor-parts-button-link" @click="listAction.copy.open(index)">別ノートに複製</span>
            <span class="note-editor-parts-button-link" @click="listAction.move.open(index, detail.lists.length)">位置を移動</span>
            <span class="note-editor-parts-button-link" @click="listAction.delete.open(index)"><FontawesomeIcon icon="times" size="sm" class="icn" /></span>
          </div>
          
        </div>
        <div :key="'button_' + index" class="button plus"
          @click="listAction.add.open(index)"
        >
          <span role="button" class="btn"><FontawesomeIcon :icon="['fal','plus']" class="icn" /></span>
        </div>
      </template>
    </div>

    <div class="note-editor-save"
      v-if="!actionSP.visibleMenu"
    >
      <div class="button save"
        :class="[!listAction.isInputDataValid && 'is-inactive']"
        @click="listAction.clickSave"
      >
        <button class="btn" 
          :disabled="!listAction.isInputDataValid" 
          type="button" name="button">保存</button>
      </div>
      <div class="button close"
        @click="historyBack"
      >
        <button class="btn" type="button" name="button"><FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" /></button>
      </div>
    </div>

    <!-- 部位の追加 -->
    <transition name="popup">
      <SPNotePartAdd
        v-if="state.visibleNotePartAdd"
        @close="listAction.add.close"
        @addText="listAction.add.addText"
        @addTextarea="listAction.add.addTextarea"
      />
    </transition>

    <!-- 部位の移動 -->
    <transition name="popup">
      <SPNotePartMove
        v-if="state.visibleNoteChangePosition"
        @close="listAction.move.close"
        @move="listAction.move.move"
        :index="state.targetListIndex"
        :length="detail.lists.length - 1"
      />
    </transition>

    <!-- 部位の削除 -->
    <transition name="popup">
      <SPNotePartDeleteConfirm
        v-if="state.visibleNotePartDeleteConfirm"
        @close="listAction.delete.close"
        @delete="listAction.delete.delete"
        :type="state.targetListType"
      />
    </transition>

    <!-- ノートパーツの複製 -->
    <transition name="popup">
      <SPNoteSelect
        v-if="state.visibleNoteSelect"
        :type="state.targetListType"
        :pageId="state.targetListLinkId"
        :title="state.targetListContent"
        :note_row_id="state.targetNoteRowId"
        :currentNoteId="currentId"
        @closeSelectNote="listAction.copy.close"
        @openCreateNote="listAction.createnote.open"
      />
    </transition>
    
    <!-- 新規ノートを作成して保存 -->
    <transition name="popup">
      <SPNoteCreate
        v-if="state.visibleNoteCreate"
        :type="state.targetListType"
        :pageId="state.targetListLinkId"
        :note_row_id="state.targetNoteRowId"
        :title="state.targetListContent"
        :currentNoteId="currentId"
        @closeCreateNote="listAction.createnote.close"
      />
    </transition>
    
    <!-- 遷移時のアラート -->
    <transition name="popup">
      <SPNotePartPreventForgettingToSave
        v-if="state.visibleNotePartPreventForgettingToSave"
        @close="listAction.forget.close"
        @move="listAction.forget.move"
        @saveAndMove="listAction.forget.saveAndMove"
      />
    </transition>

  </div>
  
</template>
<script>
import { defineComponent, reactive, computed } from '@vue/composition-api'

import VueDraggable from 'vuedraggable'
import SPNoteSelect from '@/components/sp/popup/SPNoteSelect.vue'
import SPNoteCreate from '@/components/sp/popup/SPNoteCreate.vue'
import SPNotePartAdd from '@/components/sp/popup/SPNotePartAdd.vue'
import SPNotePartMove from '@/components/sp/popup/SPNotePartMove.vue'
import SPNotePartDeleteConfirm from '@/components/sp/popup/SPNotePartDeleteConfirm.vue'
import SPNotePartPreventForgettingToSave from '@/components/sp/popup/SPNotePartPreventForgettingToSave.vue'

import { NoteEditPart } from '@/logic/note/NoteEditPart'
import { showNoteWarningDialog } from '@/logic/note/NoteWarningDialog'

export default defineComponent({
  name: 'SPNoteEditPart',
  props: {
    mode: {
      type: String
    },
    // メニュー表示フラグ（メニューボタンを押してメニューが表示されたらtrue）
    parentVisibleMenu: {
      type: Boolean,
      required: true
    }
  },
  components: {
    VueDraggable,
    SPNoteSelect,
    SPNotePartAdd,
    SPNotePartMove,
    SPNotePartDeleteConfirm,
    SPNotePartPreventForgettingToSave,
    SPNoteCreate
  },
  setup (props, context) {

    const actionSP = reactive({
      visibleMenu: computed(() => props.parentVisibleMenu)
    })

    return {
      actionSP,
      showNoteWarningDialog,
      ...NoteEditPart(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
.note-editorarea {
  .note-editor {
    &-item {
      border-bottom: 1px solid $color-line;
      padding: 20px;
      &:last-child {
        padding-bottom: 40px;
      }
      & > *:last-child {
        margin-bottom: 0!important;
      }
      &-02 {
        .error-message {
          margin: 8px 0 0;
          padding-left: 30px;
        }
        .formparts-hidden {
          margin-top: 16px;
          padding-left: 30px;
          .formparts.radio {
            display: flex;
            align-items: center;
          }
          a[role="button"] {
            margin-left: 12px;
          }
        }
      }
      &-03 {
        .txt-blue {
          display: block;
          text-align: center;
        }
      }
    }
    &-title {
      font-size: 2.0rem;
      font-weight: bold;
      color: $color-hdg;
      margin-bottom: 16px;
    }
    .list-sup {
      list-style: none;
      margin-bottom: 10px;
      li {
        display: inline-block;
        margin-right: 20px;
        color: $color-sup;
        font-size: 1.4rem;
      }
    }
    &-tags-history {
      padding-bottom: 16px;
      border-bottom: 1px solid $color-line;
    }
  }
  .note-editor-parts {
    position: relative;
    &-item {
      padding: 20px 20px 40px 20px;
      border-bottom: 1px solid $color-line;
      .formparts.text,
      .formparts.textarea {
        margin-bottom: 20px;
      }
      .category-item:not(:last-child) {
        margin-right: 1em;
      }
    }
    &-button {
      text-align: right;
      &-link {
        color: $color-link;
        font-size: 1.4rem;
        display: inline-block;
        margin-right: 20px;
        .icn {
          color: $color-content;
        }
      }
    }
    &-btnarea {
      display: flex;
      margin-right: -12px;
      .button-row-wrap {
        width: calc(100% - 50px);
        font-size: 1.4rem;
      }
      .close {
        width: 40px;
        height: 52px;
        margin-left: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: $color-content;
      }
    }
    &-linkarea {
      background-color: $color-bg-form;
      padding: 20px;
      margin-bottom: 20px;
      &-title {
        font-size: 1.6rem;
        font-weight: bold;
        color: $color-hdg;
        margin-bottom: 20px;
      }
      &-sup {
        display: inline-block;
        color: $color-sup;
        font-size: 1.4rem;
        margin-right: 20px;
      }
      &-sup2 {
        color: $color-content;
        font-size: 1.4rem;
        margin-bottom: 20px;
      }
    }
    .plus {
      margin: -24px auto 0;
    }
  }
  .note-editor-save {
    position: fixed;
    width: 100%;
    height: 78px;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    background-color: #fff;
    box-shadow: 0 -5px 30px rgba(0,0,0,.2);
    z-index: 2;
    .save {
      width: calc(100% - 93px);
      padding: 14px 0 14px 40px;
    }
    .close {
      width: 93px;
      height: 100%;
      .btn {
        border: 0;
        color: $color-sup;
        .icn {
          position: static;
        }
      }
    }
  }
}

</style>
